import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from "tailwind-variants";
import { containedCompoundVariants, dotCompoundVariants, outlinedCompoundVariants, positionVariants, surfaceCompoundVariants, textVariants, variantVariants, } from "../../theme/variants/sharedVariants";
import cn from "../../utils/cn";
const badgeVariants = tv({
    base: "text-xs font-medium flex items-center justify-center rounded-full bg-white",
    variants: {
        size: { xs: "px-1.5 py-0.5 text-[10px]", sm: "px-1.5 py-0.5", md: "px-2 py-1" },
        variant: { ...variantVariants, dot: "w-1.5 h-1.5 p-0" },
        color: textVariants,
    },
    compoundVariants: [...containedCompoundVariants, ...outlinedCompoundVariants, ...surfaceCompoundVariants, ...dotCompoundVariants],
    defaultVariants: {
        size: "sm",
        color: "default",
        variant: "default",
    },
});
const positionBadgeVariants = tv({
    base: "absolute w-fit h-fit",
    variants: {
        position: positionVariants,
    },
    defaultVariants: {
        position: "top-right",
    },
});
const Badge = ({ className, variant = "default", color = "default", children, content, max = 99, hide = false, size, position, ...props }) => {
    const shouldDisplayFullBadge = variant !== "dot";
    const shouldDisplayMax = content && Number(content) > max;
    const displayContent = shouldDisplayMax ? `${max}+` : content;
    const displayBadge = shouldDisplayFullBadge ? (_jsx("div", { "data-testid": "badge-content", className: cn(badgeVariants({ variant, className, color, size })), ...props, children: displayContent })) : (_jsx("div", { className: cn(badgeVariants({
            variant: "dot",
            className,
            size,
            color,
        })), "data-testid": "badge-dot", ...props }));
    return (_jsxs("div", { className: "relative w-fit", "data-testid": "badge", children: [children, !hide && (_jsx("div", { className: cn(positionBadgeVariants({ position })), ...props, children: displayBadge }))] }));
};
Badge.displayName = "Badge";
export default Badge;
